import { IconButton, Menu, MenuItem } from "@mui/material";
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import { ChangeDestinationCoin } from "assets/Icon";
import { useMemo } from "react";
import { useState } from "react";

function DestinationsMenu({ destinations, navigationPath = "/trade" }) {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const allSearchParams = Object.fromEntries([...searchParams]);

  const { source, destination } = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeDestination = (destination) => {
    navigate({
      pathname: `${navigationPath}/${source}/${destination?.id}`,
      search: `?${createSearchParams(allSearchParams)}`,
    });
    handleClose();
  };

  const destinationsToShow = useMemo(() => {
    const onlyCoinDestinations = destinations?.filter(
      (destination) => destination?.id > 0
    );

    const coinDestinationsOtherThanCurrentSource = onlyCoinDestinations?.filter(
      (coinDestination) => coinDestination?.id !== +source
    );

    return coinDestinationsOtherThanCurrentSource;
  }, [source, destinations]);

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="text"
      >
        <ChangeDestinationCoin />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {destinationsToShow?.map((coinDestination) => (
          <MenuItem
            selected={coinDestination?.id === +destination}
            onClick={() => handleChangeDestination(coinDestination)}
          >
            {coinDestination?.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default DestinationsMenu;
